import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AccountCard from '../../../cards/components/AccountCard';
import { CUSTOM_PRINT_TYPE } from '../../../../constants/pro-custom-prints';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    albumCustomPrint: PropTypes.shape({
      id: PropTypes.string.isRequired,
      custom_print: PropTypes.shape({
        id: PropTypes.string.isRequired,
        preview_image: PropTypes.object,
      }).isRequired,
    }).isRequired,
    configuration: PropTypes.shape({
      accountCard: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

const AccountCardCartItemPreview = ({ className, item }) => {
  const classes = classNames({
    [className]: !!className,
    'checkout-cart-item-figure': true,
  });
  const { albumCustomPrint, configuration } = item;

  return (
    <div className={classes}>
      <AccountCard
        className="account-card-cart-item-preview"
        onElementConfigurationChange={() => {}}
        accountCard={configuration.accountCard}
        viewOnly
        animatable
        disablePhotoWatermarkOverlay={
          albumCustomPrint?.custom_print?.type === CUSTOM_PRINT_TYPE.WALDOGRAM
        }
      />
    </div>
  );
};

AccountCardCartItemPreview.propTypes = propTypes;

export default AccountCardCartItemPreview;
